import {
    FETCH_MFP_LINK_STATUS,
    FETCH_MFP_LINK_STATUS_SUCCESS,
    FETCH_MFP_LINK_STATUS_FAIL
} from '../../actions/mfpActions.js';

const INITIAL_STATE = {
    mfpLinkStatus: {},
    fetching: false
};

const fetchMFPLinkStatusStart = (state) => {
    return {
        ...state,
        fetching: true
    };
};

const fetchMFPLinkStatusSuccess = (state, action) => {
    return {
        ...action.mfpLinkStatus,
        fetching: false
    };
};

const fetchMFPLinkStatusFail = (state, action) => {
    return {
        ...state.mfpLinkStatus,
        fetching: false
    };
};

const handlers = {
    [FETCH_MFP_LINK_STATUS]: fetchMFPLinkStatusStart,
    [FETCH_MFP_LINK_STATUS_SUCCESS]: fetchMFPLinkStatusSuccess,
    [FETCH_MFP_LINK_STATUS_FAIL]: fetchMFPLinkStatusFail
};

export default function mfpLinkStatus(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchMFPLinkStatus(evictCache) {
    return {
        type: FETCH_MFP_LINK_STATUS,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export const isFetchingMFPLinkStatus = (state) => {
    return state.mfpLinkStatus ? state.mfpLinkStatus.fetching : false;
};

export const getMFPLinkStatus = (state) => {
    return state.mfpLinkStatus ? state.mfpLinkStatus : {};
};

export const MFPLinkStatus = {
    ACTIVE: 1,
    DISCONNECTED: 2
};
